import { Component, Input, HostListener } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'cxContainer',
  templateUrl: './container.directive.html',
  styleUrls: [
    './container.directive.less'
  ],
})
export class ContainerDirective {

  @Input('cxClass') class: string;
  @Input('cxTitle') title: string;
  @Input('cxSubtitle') subtitle: string;
  @Input('cxLayout') layout: 'open' | 'dense';

  private toolbar: HTMLElement;
  private toolbarHeight: number = 50;
  private containerHeight: SafeStyle;

  constructor(
    private sanitizer: DomSanitizer) {
    this.containerHeight = this.desanitizedHeight();
  }

  ngDoCheck() {
    this.setHeight();
  }

  @HostListener('window:resize')
  private setHeight = () => {
    if (this.toolbar && this.toolbar.offsetHeight) {
      this.toolbarHeight = this.toolbar.offsetHeight;
      this.containerHeight = this.desanitizedHeight();
    }

    if (!this.toolbar) {
      this.toolbar = <HTMLElement>document.getElementsByClassName('toolbar')[0];
    }
  }

  private desanitizedHeight = (): SafeStyle => {
    return this.sanitizer.bypassSecurityTrustStyle('calc(100vh - ' + this.toolbarHeight + 'px)');
  }

}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/container/container.directive.ts